import Header from "../components/Header";
import Footer from "../components/Footer";

import Activities from "./Activities";
import News from "./News";
import CommitteeMembers from "./CommitteMembers";
import About from "./About";
import Gallery from "./Gallery";

import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import axios from "axios";

export default function Home() {
  const [heroImage, setHeroImage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.PARCEL_API_URL}/api/admin/hero`)
      .then((res) => {
        setHeroImage(res.data.imageUrl);
      })
      .catch((err) => console.error("API ERROR:", err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-orange-50">
      {/* 🔥 HEADER */}
      <Header />

      {/* 🔥 MAIN */}
      <main className="flex-grow">
        {/* 🔥 HERO */}
        <section className="grid md:grid-cols-2 items-center px-4 sm:px-6 md:px-16 lg:px-24 py-12 md:py-16 gap-10">
          {/* LEFT */}
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center md:text-left"
          >
            <h1 className="text-3xl sm:text-4xl md:text-6xl font-extrabold mb-4 leading-tight">
              <span className="bg-gradient-to-r from-orange-400 via-orange-500 to-amber-500 bg-clip-text text-transparent">
                St.George
              </span>
              <br />
              <span className="bg-gradient-to-r from-orange-400 to-amber-500 bg-clip-text text-transparent">
                Youth Association
              </span>
              <p className="text-lg sm:text-xl md:text-2xl mt-2 bg-gradient-to-r from-orange-400 via-orange-500 to-amber-500 bg-clip-text text-transparent">
                Chelakkara
              </p>
            </h1>
          </motion.div>

          {/* RIGHT IMAGE */}
          <motion.div
            initial={{ opacity: 0, x: 60 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="flex justify-center"
          >
            {loading ? (
              <div className="w-full max-w-md h-52 sm:h-64 md:h-80 rounded-xl bg-gray-200 animate-pulse"></div>
            ) : heroImage ? (
              <img
                src={heroImage}
                alt="Hero"
                className="w-full max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl rounded-2xl shadow-2xl object-cover"
              />
            ) : (
              <p className="text-gray-400">No image</p>
            )}
          </motion.div>
        </section>

        {/* 🔥 SECTIONS */}
        <div className="space-y-10 md:space-y-14">
          <Activities showFooter={false} isPage={false} />
          <News preview={true} showFooter={false} isPage={false} />
          <CommitteeMembers />
          <Gallery isPreview={true} isPage={false} />
          <About isPage={false} />
        </div>
      </main>

      {/* 🔥 FOOTER */}
      <Footer />
    </div>
  );
}
